<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_3 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<!--<div-->
		<!--	:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"-->
		<!--	class="my-4"-->
		<!--&gt;</div>-->
		
		<!--<v-row class="mb-5 font-weight-medium">-->
		<!--	<v-col>-->
		<!--		<div v-html="faseWithStati.descrizione"></div>-->
		<!--	</v-col>-->
		<!--</v-row>-->
		
		<template v-if="isAccountManager">
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('cliccatore_id')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-autocomplete
							:items="cliccatoriNonAssegnati"
							v-model="pratica.cliccatore"
							return-object
							:loading="isLoadingCliccatoriNonAssegnati"
							label="Assegna un cliccatore"
							item-value="id"
							item-text="username_codice_cliccatore"
							outlined
							dense
							clearable
							@click:clear="pratica.cliccatore = Object.assign({}, praticaVoid.cliccatore)"
							:disabled="isLoading"
						></v-autocomplete>
					</v-badge>
				</v-col>
			</v-row>
		
			<!--<template v-if="pratica.cliccatore_id === null">-->
			<!--	Nessun cliccatore assegnato-->
			<!--</template>-->
			<!--<template v-else>-->
			<!--	Ti abbiamo assegnato il cliccatore con codice {{ pratica.cliccatore.codice_cliccatore || 'NESSUN CODICE CLICCATORE' }}-->
			<!--</template>-->
		</template>

		<template v-if="sonoVisibiliIDatiDelCliccatore">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 text-h6"
			>
				<span class="tertiary--text">
					Dati del cliccatore
				</span>
			</v-sheet>

			<!-- il link arriva dal backend solo per il cliccatore salvato sulla pratica -->
			<v-row v-if="pratica.cliccatore?.link_dati_cliccatore">
				<v-col
					cols="12"
					class="d-flex align-center"
				>
					<a
						:href="pratica.cliccatore.link_dati_cliccatore"
						target="_blank"
						rel="noopener"
					>
						Link per la visualizzazione del cliccatore
					</a>
					<v-btn
						icon
						small
						class="ml-1"
						@click="copiaLinkDatiCliccatore(pratica.cliccatore.link_dati_cliccatore)"
						title="Copia il link"
					>
						<v-icon small>mdi-content-copy</v-icon>
					</v-btn>
				</v-col>
			</v-row>

			<v-progress-linear
				v-if="isLoadingDatiModificabiliCliccatore"
				indeterminate
				class="mb-3"
			></v-progress-linear>

			<v-row>
				<v-col
					v-for="datoCliccatore in datiCliccatoreDaMostrare"
					:key="datoCliccatore.etichetta"
					cols="6"
				>
					<v-text-field
						:value="datoCliccatore.valore"
						:label="datoCliccatore.etichetta"
						outlined
						dense
						hide-details
						readonly
						persistent-placeholder
					></v-text-field>
				</v-col>
			</v-row>
		</template>

	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_3: null,
				ci_sono_aggiornamenti_fase_3: false,
				cliccatore_id: null,
				cliccatore: {
					id: null,
					username: null,
					codice_cliccatore: null
				}
			},
			isLoadingCliccatoriNonAssegnati: false,
			cliccatoriNonAssegnati: [],
			isLoadingDatiModificabiliCliccatore: false,
			idStatoDaAssegnare: 181,
			idStatoCliccatoreAssegnato: 182,
			idStatoFaseCompletataCliccatoreDelegato: 204
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_3 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_3 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_3',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_3');
		}
		
		this.getCliccatoriNonAssegnati();
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingCliccatoriNonAssegnati;
		},
		// stato DA ASSEGNARE: solo gli account manager; stati CLICCATORE ASSEGNATO e CLICCATORE DELEGATO: tutti
		sonoVisibiliIDatiDelCliccatore() {
			if (!this.pratica.cliccatore_id) return false;

			if ([this.idStatoCliccatoreAssegnato, this.idStatoFaseCompletataCliccatoreDelegato].includes(Number(this.pratica.id_stato_fase_3))) return true;

			return this.pratica.id_stato_fase_3 == this.idStatoDaAssegnare && this.isAccountManager;
		},
		// chiavi di dati_modificabili del simulatore, valorizzate dal backend solo per il cliccatore salvato sulla pratica
		datiCliccatoreDaMostrare() {
			const datiCliccatore = this.pratica.cliccatore?.dati_modificabili_validi ?? {};

			return [
				{ etichetta: 'Nome cliccatore', valore: datiCliccatore.nome_cl },
				{ etichetta: 'Cognome cliccatore', valore: datiCliccatore.cognome_cl },
				{ etichetta: 'Genere', valore: datiCliccatore.genere_cl },
				{ etichetta: 'Città di nascita', valore: datiCliccatore.comune_o_stato_estero_nascita_firm_ist },
				{ etichetta: 'Data di nascita', valore: datiCliccatore.data_nascita_cl },
				{ etichetta: 'Codice Fiscale', valore: datiCliccatore.codice_fiscale_cl },
				{ etichetta: 'Nazione residenza', valore: datiCliccatore.nazione_az },
				{ etichetta: 'Regione residenza', valore: datiCliccatore.regione_azienda },
				{ etichetta: 'Provincia residenza', valore: datiCliccatore.provincia_az },
				{ etichetta: 'Comune residenza', valore: datiCliccatore.comune_az },
				{ etichetta: 'Indirizzo residenza', valore: datiCliccatore.indirizzo_az },
				{ etichetta: 'Numero Civico residenza', valore: datiCliccatore.civico_az },
				{ etichetta: 'CAP residenza', valore: datiCliccatore.cap_az },
				{ etichetta: 'Ruolo', valore: 'Consulente esterno' },
				{ etichetta: 'Email', valore: datiCliccatore.email_cl },
				{ etichetta: 'PEC', valore: datiCliccatore.pec },
				{ etichetta: 'Tipo documento di riconoscimento', valore: datiCliccatore.doc_identita_tipo_cl },
				{ etichetta: 'Numero documento', valore: datiCliccatore.doc_identita_numero_cl },
				{ etichetta: 'Rilasciato da', valore: datiCliccatore.doc_identita_rilasciato_cl },
				{ etichetta: 'Data di rilascio', valore: datiCliccatore.data_rilascio_doc_identita_cl },
			];
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		'pratica.cliccatore': function (cliccatore) {
			if (cliccatore === null) this.pratica.cliccatore = Object.assign({}, this.praticaVoid.cliccatore);
			this.pratica.cliccatore_id = this.pratica.cliccatore.id;

			// il cliccatore scelto dall'autocomplete non ha i dati del simulatore: li carico subito
			if (this.pratica.cliccatore.id && !this.pratica.cliccatore.dati_modificabili_validi) {
				this.getDatiModificabiliCliccatore(this.pratica.cliccatore.id);
			}
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
		getCliccatoriNonAssegnati() {
			this.isLoadingCliccatoriNonAssegnati = true;
			axios.get(`/api/cliccatori-non-assegnati${this.pratica.cliccatore_id ? '?except=' + this.pratica.cliccatore_id : ''}`)
				.then(response => {
					this.cliccatoriNonAssegnati = response.data;
				})
				.finally(() => {
					this.isLoadingCliccatoriNonAssegnati = false;
				})
		},
		getDatiModificabiliCliccatore(cliccatoreId) {
			this.isLoadingDatiModificabiliCliccatore = true;
			axios.get(`/api/cliccatori/${cliccatoreId}/dati-modificabili`)
				.then(response => {
					// se nel frattempo è stato scelto un altro cliccatore ignoro la risposta
					if (this.pratica.cliccatore?.id !== cliccatoreId) return;

					this.$set(this.pratica.cliccatore, 'dati_modificabili_validi', response.data);
				})
				.finally(() => {
					this.isLoadingDatiModificabiliCliccatore = false;
				})
		}
	}
	
}
</script>

<style scoped>

</style>